import React from "react";
import { CardContent, Typography, Box, Stack, Grid } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";

function Assets({ responseFem, responseBem }) {
  const navigate = useNavigate();

  const femCards = [
    { label: "Authorised", count: responseFem?.assetAuthorizedCount, color: "success.dashboard" },
    { label: "Functioning", count: responseFem?.assetFunctioningCount, color: "success.dashboard" },
    { label: "Disposed", count: responseFem?.assetDisposedCount, color: "success.dashboard" },
    { label: "Not In Use", count: responseFem?.asseNotInUseCount, color: "success.dashboard" },
    { label: "Not Functioning", count: responseFem?.assetNonFunctioningCount, color: "success.dashboard" },
    { label: "Transferred", count: responseFem?.assetTransferredCount, color: "success.dashboard" },
    { label: "Unauthorised", count: responseFem?.assetUnauthorizedCount, color: "error.dashboard" },
  ];

  const bemCards = [
    { label: "Authorised", count: responseBem?.assetAuthorizedCount, color: "success.dashboard" },
    { label: "Functioning", count: responseBem?.assetFunctioningCount, color: "success.dashboard" },
    { label: "Disposed", count: responseBem?.assetDisposedCount, color: "success.dashboard" },
    { label: "Not In Use", count: responseBem?.asseNotInUseCount, color: "success.dashboard" },
    { label: "Not Functioning", count: responseBem?.assetNonFunctioningCount, color: "success.dashboard" },
    { label: "Transferred", count: responseBem?.assetTransferredCount, color: "success.dashboard" },
    { label: "Unauthorised", count: responseBem?.assetUnauthorizedCount, color: "error.dashboard" },
  ];

  const renderAssetGrid = (title, cards, route) => (
    <StyledCard variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Typography mb={1.5} variant="h6" fontWeight={700} color="text.primary">
          {title}
        </Typography>
        <Grid container spacing={2}>
          {cards.map((card, index) => (
            <Grid
              key={index}
              item
              xs={12} sm={6} md={3} lg={3}
              sx={{ cursor: "pointer" }}
              onClick={() => navigate(route)}
            >
              <StyledCard variant="outlined" sx={{ height: '90%' }}>
                <CardContent>
                  <Typography mb={1} fontSize={12} color="text.primary">
                    {card.label}
                  </Typography>
                  <Typography variant="h1" color={card.color}>
                    {card.count}
                  </Typography>
                </CardContent>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </StyledCard>
  );

  return (
    <StyledCard variant="outlined">
      <CardContent>
        <Typography mb={2} variant="h5" fontWeight={700} color="text.primary">
          Asset Status
        </Typography>

        <Stack spacing={2}>
          {renderAssetGrid("FEMS", femCards, "/assetsFEM")}
          {renderAssetGrid("BEMS", bemCards, "/assetsBEM")}
        </Stack>

      </CardContent>
    </StyledCard>
  );
}

export default Assets;
